<script setup>
import { useModalogStore } from "@/stores/modalog.js";
import SvgAdd from "~/svg/icon-add.svg";

const props = defineProps({
    list: {
        type: Object,
        required: true,
    },
});

const { showModalog } = useModalogStore();

function addGift() {
    showModalog({
        type: "ModalogAddGiftBrand",
        props: {
            listType: props.list.type,
            listUuid: props.list.uuid,
        },
    });
}
</script>

<template>
    <button
        type="button"
        class="flex items-center justify-center gap-4 rounded-[4px] transition max-lg:h-[116px] max-lg:border max-lg:border-dashed max-lg:border-brand-navy max-lg:bg-brand-navy/[0.08] max-lg:hover:bg-brand-navy/[0.14] lg:min-h-[304px] lg:flex-col lg:bg-[#d8cecb]/60 lg:hover:bg-[#d8cecb]"
        @click="addGift"
    >
        <SvgAdd
            class="size-12 fill-current text-brand-red lg:size-[62px]"
            aria-hidden="true"
        />
        <span class="font-brand text-[20px] font-bold text-[#102a3d]">
            Add a Gift
        </span>
    </button>
</template>
